import React from "react";

const Services = ({ classicHeader, darkTheme }) => {
  // services details
  const services = [
    {
      name: "Native Android",
      desc: "Android is where my career began back in 2013. Over the years, I've built and maintained production apps, worked deep in the Android SDK, and learned how to balance performance, reliability, and user experience. It's the platform that shaped how I think about mobile engineering.",
      image: "images/android.svg",
    },
    {
      name: "Flutter Apps",
      desc: `I picked up Flutter in 2018 out of curiosity and quickly saw its potential. What started as exploration turned into a powerful way to ship cross-platform apps efficiently—without letting go of the mobile engineering principles I learned through years of native Android development.`,
      image: "images/flutter.svg",
      // icon: "fa-solid fa-cloud",
    },
    {
      name: "Backend Engineering",
      desc: "I design, build, and maintain the server-side systems that power mobile apps. I enjoy shaping backend logic with tools like Node.js and Express, working with both SQL and NoSQL databases, and making thoughtful decisions around data storage and scalability. I'm a strong believer in serverless architectures when they make sense, and I often take ownership of deployment and hosting—especially for self-hosted solutions—to ensure everything runs smoothly end to end.",
      image: "images/cloud.svg",
    },
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Services
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do?
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        {service.icon ? (<i className={service.icon} />) : (
                          <img
                            src={service.image}
                            width="32"
                            height="32"
                            alt=""
                          />)}

                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
